import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdown",
  "use": "icon-dropdown-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol viewBox=\"0 0 14 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dropdown\">\n<path d=\"M12.9977 1.00159L6.99647 7.00281L0.995239 1.00159\" stroke=\"#999999\" stroke-width=\"1.7169\" stroke-linejoin=\"bevel\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol